import React from 'react';
import { Tooltip } from 'antd';
import Bind from 'lodash-decorators/bind';
import {TooltipProps} from 'antd/lib/tooltip';
interface IState {
    showPopover: boolean;
}

export default class PopoverEllipsis extends React.Component<TooltipProps, IState> {
    public children: any = null;
    public timeHandler: any = -1;
    constructor(props: TooltipProps) {
        super(props);
        this.state = {
            showPopover: false,
        };
    }

    @Bind
    public validShowPopover(): void {
        if (!this.children) {
            return;
        }
        const { scrollWidth, clientWidth, scrollHeight, clientHeight} = this.children;
        this.setState({
            showPopover: (scrollWidth > clientWidth) || (scrollHeight > clientHeight)
        });
    }

    @Bind
    public onMouseEnter() {
        clearTimeout(this.timeHandler);
        this.timeHandler = setTimeout(() => {
            this.validShowPopover();
        }, 200);
    }

    @Bind()
    private onMouseLeave(): void {
        clearTimeout(this.timeHandler);
        this.setState({
            showPopover: false
        });
    }

    public refChildren = (ref) => {
        this.children = ref;
    }

    public renderChildren() {
        return (
            React.cloneElement(
                this.props.children as React.ReactElement, {
                    ref: this.refChildren,
                    onMouseEnter: this.onMouseEnter,
                    onMouseLeave: this.onMouseLeave
                }
            )
        );
    }

    public render() {
        return (
            <Tooltip
                {...this.props}
                visible={this.children && this.state.showPopover}
            >
                { this.renderChildren() }
            </Tooltip>
        );
    }
}
